import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSelect } from '@angular/material';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { ISelection } from '../../../../core/interfaces/common/selection';

@Component({
  selector: 'app-multiple-selection',
  templateUrl: './multiple-selection.component.html',
  styleUrls: ['./multiple-selection.component.scss']
})
export class MultipleSelectionComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  /** list of items */
  @Input() items: ISelection[];

  /** selected items */
  @Input() selectedItems: ISelection[];

  /** name of selection component */
  @Input() title: string;

  /** list of items to be returned */
  @Output() editedItems = new EventEmitter<ISelection[]>();

  /** control for the selected item for multi-selection */
  public itemMultiCtrl: FormControl = new FormControl();

  /** control for the MatSelect filter keyword multi-selection */
  public itemMultiFilterCtrl: FormControl = new FormControl();

  /** list of items filtered by search keyword */
  public filteredItemsMulti: ReplaySubject<ISelection[]> = new ReplaySubject<ISelection[]>(1);

  @ViewChild('multiSelect', { static: true }) multiSelect: MatSelect;

  /** Subject that emits when the component has been destroyed. */
  protected _onDestroy = new Subject<void>();


  constructor() { }

  ngOnInit() {
    this.loadSelection();
  }

  ngAfterViewInit() {
    this.setInitialValue();
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.items != undefined) {
      this.items = changes.items.currentValue;
    }

    if (changes.selectedItems != undefined) {
      this.selectedItems = changes.selectedItems.currentValue;
    }

    this.loadSelection();
  }

  loadSelection() {
    // set initial selection
    this.itemMultiCtrl.setValue(this.selectedItems);

    // load the initial item list
    this.filteredItemsMulti.next(this.items.slice());

    // listen for search field value changes
    this.itemMultiFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterItemsMulti();
      });
  }

  /**
   * Sets the initial value after the filteredItems are loaded initially
   */
  protected setInitialValue() {
    this.filteredItemsMulti
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        // setting the compareWith property to a comparison function
        // triggers initializing the selection according to the initial value of
        // the form control (i.e. _initializeSelection())
        // this needs to be done after the filteredItems are loaded initially
        // and after the mat-option elements are available
        this.multiSelect.compareWith = (a: ISelection, b: ISelection) => a && b && a.value === b.value;
      });
  }

  protected filterItemsMulti() {
    if (!this.items) {
      return;
    }
    // get the search keyword
    let search = this.itemMultiFilterCtrl.value;
    if (!search) {
      this.filteredItemsMulti.next(this.items.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the items
    this.filteredItemsMulti.next(
      this.items.filter(item => item.text.toLowerCase().indexOf(search) > -1)
    );
  }

  onChange($event) {
    this.editedItems.emit($event.value);
  }
}
